import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Device from "Components/Shared/Device/Device";
//import DeviceNotifications from "Components/Shared/DeviceNotifications/DeviceNotifications";
//import Table from "Components/Shared/Table/Table";
import AttentionBox from "Components/Shared/AttentionBox/AttentionBox";
import SideBar from "Components/Shared/SideBar/SideBar";

//import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//import ViewCompactIcon from "@mui/icons-material/ViewCompact";
//import ViewModuleIcon from "@mui/icons-material/ViewModule";
import Switch from "@mui/material/Switch";

import SiteRow from "./SiteRow";
import BottomBar from "Components/Shared/BottomBar/BottomBar";

//redux setup
import { useSelector, useDispatch } from "react-redux";
import { setOriginalDevices, setDevices, filterDevices, resetDevices, /* setNotifications */ setFocussedDevice, setView, setOptimizeView, setDeviceHistories } from "Store/home";

import "./Home.css";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

const Home = () => {
  const state = useSelector((state: any) => state.homeState);
  const dispatch = useDispatch();
  const redirect = useNavigate();

  const serverUrl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SERVER_HOST}:${process.env.REACT_APP_SERVER_HOST_PORT}`;

  useEffect(() => {
    const fetchData = () => {
      axios
        .get(`${serverUrl}/api/devices`, {
          withCredentials: true,
        })
        .then(async function (response) {
          const apiData = await response.data;

          if (apiData.status === "success") {
            dispatch(setOriginalDevices(apiData.data));
            dispatch(setDevices(apiData.data));
          } else {
            dispatch(setDevices([]));
          }
        })
        .catch(function (error) {
          console.error(error);
          dispatch(setDevices([]));
        });
    };
    fetchData();
  }, [dispatch, serverUrl]);

  useEffect(() => {
    const fetchHistoryData = () => {
      axios
        .post(`${serverUrl}/api/device-history-all`, null, {
          withCredentials: true,
        })
        .then(async function (response) {
          const apiData = await response.data;

          if (apiData.status === "success") {
            const { min5, hour, hour24 } = apiData.data;

            const mapMin5: Record<string, any[]> = {};
            min5?.forEach((item: any) => {
              if (!mapMin5[item.device]) mapMin5[item.device] = [];
              mapMin5[item.device].push(item);
            });

            const mapHour: Record<string, any[]> = {};
            hour?.forEach((item: any) => {
              if (!mapHour[item.device]) mapHour[item.device] = [];
              mapHour[item.device].push(item);
            });

            const mapHour24: Record<string, any[]> = {};
            hour24?.forEach((item: any) => {
              if (!mapHour24[item.device]) mapHour24[item.device] = [];
              mapHour24[item.device].push(item);
            });

            dispatch(setDeviceHistories({
              min5: mapMin5,
              hour: mapHour,
              hour24: mapHour24,
            }));
          }
        })
        .catch(function (error) {
          console.error("Error fetching device history:", error);
        });
    };
    
    fetchHistoryData();

    const intervalId = setInterval(() => {
      fetchHistoryData();
    }, 300000);

    return () => clearInterval(intervalId);
  }, [dispatch, serverUrl]);

  const groupedBySite = (myData: any) => {
    return myData.reduce((group: any, site: any) => {
      const { siteName } = site;

      if (!group[siteName]) {
        group[siteName] = [];
      }

      group[siteName].push(site);
      return group;
    }, {});
  };

  const objectConvert = (myObject: any) => {
    const newArray = Object.entries(myObject);
    return newArray;
  };

  // useEffect(() => {
  // 	const fetchData = () => {
  // 		axios
  // 			.get("/data/deviceNotifications.json")
  // 			.then(async function (response) {
  // 				const apiData = await response.data;

  // 				apiData.status === "Successful"
  // 					? dispatch(setNotifications(apiData.data))
  // 					: dispatch(setNotifications([]));
  // 			})
  // 			.catch(function (error) {
  // 				console.error(error);
  // 				dispatch(setNotifications([]));
  // 			});
  // 	};
  // 	fetchData();
  // 	// eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const handleUrl = (deviceID: number) => {
    redirect(`/device/${deviceID}`);
  };

  //https://stackoverflow.com/questions/57554145/ag-grid-react-cellmouseout-event-not-being-fired
  const onCellMouseOver = (e: any) => {
    dispatch(setFocussedDevice(e.node.data.deviceId));
  };

  const onCellMouseOut = () => {
    dispatch(setFocussedDevice(""));
  };

  const [selectedStatus, setSelectedStatus] = useState({
    value: "",
    label: "Status",
  });
  const [selectedClient, setSelectedClient] = useState({
    value: "",
    label: "Client",
  });
  const [selectedSite, setSelectedSite] = useState({
    value: "",
    label: "Site",
  });
  const [selectedBuilding, setSelectedBuilding] = useState({
    value: "",
    label: "Building",
  });
  const [selectedArea, setSelectedArea] = useState({
    value: "",
    label: "Area",
  });

  const [clients, setClients] = useState([]);
  const [sites, setSites] = useState([]);
  const [siteVisibility, setSiteVisibility] = useState(false);
  const [buildings, setBuildings] = useState([]);
  const [buildingVisibility, setBuildingVisibility] = useState(false);
  const [areas, setAreas] = useState([]);
  const [areaVisibility, setAreaVisibility] = useState(false);

  const fetchEntityData = useCallback(
    (param: string, body: any) => {
      axios
        .post(`${serverUrl}/api/${param}`, body, {
          withCredentials: true,
        })
        .then(async function (response) {
          const apiData = await response.data;

          const setData = () => {
            switch (param) {
              case "clients":
                setClients(apiData.data);
                return;
              case "sites":
                setSites(apiData.data);
                return;
              case "buildings":
                setBuildings(apiData.data);
                return;
              case "areas":
                setAreas(apiData.data);
                return;
            }
          };

          apiData.status === "success" ? setData() : console.log("error fetching data");
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    [serverUrl],
  );

  useEffect(() => {
    fetchEntityData("clients", {});
    // fetchEntityData("sites", { clientId: device.client });
    // fetchEntityData("buildings", { siteId: device.site });
    // fetchEntityData("areas", { buildingId: device.building });
  }, [fetchEntityData]);

  const handleStatusFilter = (value: any, type: string) => {
    switch (type) {
      case "status":
        handleReset();
        setSelectedStatus(value);
        dispatch(filterDevices(value));
        return;
      case "client":
        handleReset();
        setSelectedClient(value);
        fetchEntityData("sites", { clientId: JSON.parse(value).value });
        dispatch(filterDevices(value));
        setSiteVisibility(true);
        return;
      case "site":
        setSelectedSite(value);
        fetchEntityData("buildings", { siteId: JSON.parse(value).value });
        dispatch(filterDevices(value));
        setBuildingVisibility(true);
        setAreaVisibility(false);
        return;
      case "building":
        setSelectedBuilding(value);
        fetchEntityData("areas", { buildingId: JSON.parse(value).value });
        dispatch(filterDevices(value));
        setAreaVisibility(true);
        return;
      case "area":
        setSelectedArea(value);
        dispatch(filterDevices(value));
        return;
    }
  };

  const handleReset = () => {
    setSelectedStatus({ value: "", label: "Status" });
    setSelectedClient({ value: "", label: "Client" });
    setSelectedSite({ value: "", label: "Site" });
    setSelectedBuilding({ value: "", label: "Building" });
    setSelectedArea({ value: "", label: "Area" });
    setSiteVisibility(false);
    setBuildingVisibility(false);
    setAreaVisibility(false);
    dispatch(resetDevices());
  };

  const optionsStatus: any = [
    { value: '{"type": "powerOn", "value": 0}', label: "Power off" },
    { value: '{"type": "coolerOn", "value": 100}', label: "Cooling activated" },
    { value: '{"type": "heaterOn", "value": 100}', label: "Heating activated" },
    { value: '{"type": "hot"}', label: "Too Hot" },
    { value: '{"type": "cold"}', label: "Too Cold" },
    { value: '{"type": "range"}', label: "Out of Range" },
  ];

  const optionsClient: any = clients.map((client: any) => {
    return {
      value: `{"type": "client", "value": ${client.id}}`,
      label: `${client.name}`,
    };
  });

  const optionsSites: any = sites.map((site: any) => {
    return {
      value: `{"type": "site", "value": ${site.id}}`,
      label: `${site.name}`,
    };
  });

  const optionsBuildings: any = buildings.map((building: any) => {
    return {
      value: `{"type": "building", "value": ${building.id}}`,
      label: `${building.name}`,
    };
  });

  const optionsAreas: any = areas.map((area: any) => {
    return {
      value: `{"type": "area", "value": ${area.id}}`,
      label: `${area.name}`,
    };
  });

  const handleView = () => {
    dispatch(setView());
  };

  const handleOptimizeView = () => {
    dispatch(setOptimizeView());
  };

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      requestAnimationFrame(() => {
        for (let entry of entries) {
          // safely trigger any updates
          // avoid state changes directly in this block if possible
        }
      });
    });

    observer.observe(document.body); // or any element
    return () => observer.disconnect();
  }, []);

  const [mobileFilter, setMobileFilter] = useState(true);

  const handleMobileFilters = () => {
    if (mobileFilter) {
      setMobileFilter(false);
    } else {
      setMobileFilter(true);
    }
  };

  return (
    <div className="mobi-home-div">
      <BottomBar alerts={state.alarmNotifications.length} />
      <Row className={"home-container"}>
        <Col md={1} className="sidebar-col">
          <SideBar />
        </Col>
        <Col md={11} className="main-col">
          <Row>
            <h4 className="device-heading">Device Monitoring</h4>
            <button
              className="hide-show-mobi-filters"
              onClick={() => {
                handleMobileFilters();
              }}
            >
              {mobileFilter ? <FilterAltIcon /> : <FilterAltOffIcon />}
            </button>
            <Col md={9} className="device-row">
              <Row className="filter-row" style={!mobileFilter ? { display: "none" } : { display: "flex" }}>
                <Col md={1} xs={2}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Switch onClick={() => handleView()} color="success" checked={state.viewLabel} />
                    <label
                      style={{
                        padding: 0,
                        margin: "-8px 0 0",
                        fontSize: "10px",
                      }}
                    >
                      Hide Charts
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Switch onClick={() => handleOptimizeView()} color="success" checked={state.optimizeViewLabel} />
                    <label
                      style={{
                        padding: 0,
                        margin: "-8px 0 0",
                        fontSize: "10px",
                      }}
                    >
                      Segment
                    </label>
                  </div>
                </Col>
                <Col xs={5} md={2} style={{ padding: " 0 3px" }}>
                  <Select
                    className="select"
                    placeholder={selectedStatus.label}
                    options={optionsStatus}
                    onChange={(e: any) => handleStatusFilter(e.value, "status")}
                    value={selectedStatus.value}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Col>
                <Col xs={5} md={2} style={{ padding: " 0 3px" }}>
                  <Select
                    className="select"
                    placeholder={selectedClient.label}
                    options={optionsClient}
                    onChange={(e: any) => handleStatusFilter(e.value, "client")}
                    value={selectedClient.value}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </Col>
                {siteVisibility && (
                  <Col xs={5} md={2} style={{ padding: " 0 3px" }}>
                    <Select
                      className="select"
                      placeholder={selectedSite.label}
                      options={optionsSites}
                      onChange={(e: any) => handleStatusFilter(e.value, "site")}
                      value={selectedSite.value}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </Col>
                )}
                {buildingVisibility && (
                  <Col xs={5} md={2} style={{ padding: " 0 3px" }}>
                    <Select
                      className="select"
                      placeholder={selectedBuilding.label}
                      options={optionsBuildings}
                      onChange={(e: any) => handleStatusFilter(e.value, "building")}
                      value={selectedBuilding.value}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </Col>
                )}
                {areaVisibility && (
                  <Col xs={5} md={2} style={{ padding: " 0 3px" }}>
                    <Select
                      className="select"
                      placeholder={selectedArea.label}
                      options={optionsAreas}
                      onChange={(e: any) => handleStatusFilter(e.value, "area")}
                      value={selectedArea.value}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                    />
                  </Col>
                )}

                <Col xs={5} md={1}>
                  <button className="reset-btn" onClick={() => handleReset()}>
                    Reset
                  </button>
                </Col>
              </Row>
              {state.optimizeView === 2 ? (
                state.devices.length > 0 ? (
                  <Row className="gauge-row">
                    <h6 style={{ padding: 0, margin: "0 8px" }}>All sites</h6>
                    {state.devices.map((device: any) => (
                      <Col onClick={() => handleUrl(device.deviceId)} xs={4} md={2} key={device.deviceId} style={{ padding: "5px" }}>
                        <Device device={device} state={""} graph={state.view === 1 ? true : false} show={true} myGraph={true} page="home" />
                      </Col>
                    ))}
                  </Row>
                ) : (
                  <p>No device data :(</p>
                )
              ) : objectConvert(groupedBySite(state.devices)).length > 0 ? (
                objectConvert(groupedBySite(state.devices)).map((device: any, index: number) => <SiteRow key={index} siteData={device} />)
              ) : (
                <p>No device data :(</p>
              )}
            </Col>
            <Col md={3} sm={12}>
              <Row>
                <Col md={12}>
                  <AttentionBox rowData={state.alarmNotifications} header="Needs Attention" mainClass="attention-box" secondaryClass="attention-item" page="home" />
                </Col>
                <Col md={12}>
                  <AttentionBox rowData={state.deviceNotifications} header="Latest Activity" mainClass="activity-box" secondaryClass="activity-item" page="home" />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Home;
